import { EnvironmentProviders, Provider } from '@angular/core';

export function getDashboardDataServiceProvider(): Provider[] {
  return [];
}

export function getDashboardDataProviderDataProviders(): Array<Provider | EnvironmentProviders> {
  return [];
}
